<template>
  <div class="section section-center">
    <div class="login-wrap">
      <Welcome text="Восстановление пароля">
        <div class="text-secondary ts-center">
          Введите новый пароль ниже.<br>Рекомендуем сохранить его в
          <a
            href="https://1password.com/"
            target="_blank"
            ref="noreferrer nofollow"
            class="link"
          >
            1Password
          </a>,&nbsp;
          <a
            href="https://www.lastpass.com/"
            target="_blank"
            ref="noreferrer nofollow"
            class="link"
          >
            Lastpass</a>&nbsp;
          <br>или другой менеджер паролей, чтобы больше не забывать!
        </div>
      </Welcome>

      <RestoreForm />
    </div>
  </div>
</template>

<script>
  import Welcome from '@/containers/auth/Welcome';
  import RestoreForm from '@/containers/auth/RestoreForm';

  export default {
    name: 'Reset',
    components: {RestoreForm, Welcome},
  };
</script>
